import {endpoints} from "App"
export async function postPayDeposit(url: any, params:any, callback: any){
    //url="http://pricingapistaging.allmysons.com/Estimator/SavePaymentCreditCard"
    url=endpoints.payment
    var http = new XMLHttpRequest();
    http.open("POST", url, true);
    http.setRequestHeader('Accept', 'application/json');
    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    //http.setRequestHeader("Content-type", "application/json");
    console.log("url:"+url);
    console.log("params:"+JSON.stringify(params));
    http.onreadystatechange = function () {
        if (http.readyState === 4 && http.status === 200) {
            console.log("firing callback");
          callback(http.responseText);
        }
    }
    http.send( JSON.stringify(params));
}


export async function makeRequest (url: any, params:any) {
  var full_url = endpoints.estimator+url;
  var formBody:any = [];
  for (var property in params) {
  var encodedKey = encodeURIComponent(property);
  var encodedValue = encodeURIComponent(params[property]);
  formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  console.log("full_url:",full_url);
  console.log("formBody",formBody);

  const response = await fetch(full_url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: formBody
  });
  return response.json(); // parses JSON response into native JavaScript objects
}